/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type StudioIsAllAccessUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StudioIsAllAccessUserQuery = { __typename?: 'Query', studioIsAllAccessUser: { __typename?: 'StudioIsAllAccessUserResponse', allAccessUser?: boolean | null } };

export type StudioIsStudioAiUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StudioIsStudioAiUserQuery = { __typename?: 'Query', studioIsStudioAIUser: { __typename?: 'StudioIsAIStudioUserResponse', studioAIUser?: boolean | null } };


export const StudioIsAllAccessUserDocument = `
query studioIsAllAccessUser {
  studioIsAllAccessUser {
    allAccessUser
  }
}

`

export const studioIsAllAccessUserQueryRootKey = 'studioIsAllAccessUser'

export function studioIsAllAccessUserQueryFetcher(variables?: StudioIsAllAccessUserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<StudioIsAllAccessUserQuery, StudioIsAllAccessUserQueryVariables>(StudioIsAllAccessUserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function studioIsAllAccessUserQueryKey(variables?: StudioIsAllAccessUserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [studioIsAllAccessUserQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function studioIsAllAccessUserQueryOptions(
    variables?: StudioIsAllAccessUserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<StudioIsAllAccessUserQuery, unknown, StudioIsAllAccessUserQuery, (StudioIsAllAccessUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: studioIsAllAccessUserQueryKey(variables, fetchOptions),
        queryFn: studioIsAllAccessUserQueryFetcher(variables, fetchOptions),
    }
}

export function useStudioIsAllAccessUserQuery<D = StudioIsAllAccessUserQuery, E = unknown>(
    variables?: StudioIsAllAccessUserQueryVariables,
    options?: Omit<UseQueryOptions<StudioIsAllAccessUserQuery, E, D, (StudioIsAllAccessUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<StudioIsAllAccessUserQuery, E, D, (StudioIsAllAccessUserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...studioIsAllAccessUserQueryOptions(variables, fetchOptions),
    })
}

export const StudioIsStudioAiUserDocument = `
query studioIsStudioAIUser {
  studioIsStudioAIUser {
    studioAIUser
  }
}

`

export const studioIsStudioAIUserQueryRootKey = 'studioIsStudioAIUser'

export function studioIsStudioAIUserQueryFetcher(variables?: StudioIsStudioAiUserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<StudioIsStudioAiUserQuery, StudioIsStudioAiUserQueryVariables>(StudioIsStudioAiUserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function studioIsStudioAIUserQueryKey(variables?: StudioIsStudioAiUserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [studioIsStudioAIUserQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function studioIsStudioAIUserQueryOptions(
    variables?: StudioIsStudioAiUserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<StudioIsStudioAiUserQuery, unknown, StudioIsStudioAiUserQuery, (StudioIsStudioAiUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: studioIsStudioAIUserQueryKey(variables, fetchOptions),
        queryFn: studioIsStudioAIUserQueryFetcher(variables, fetchOptions),
    }
}

export function useStudioIsStudioAiUserQuery<D = StudioIsStudioAiUserQuery, E = unknown>(
    variables?: StudioIsStudioAiUserQueryVariables,
    options?: Omit<UseQueryOptions<StudioIsStudioAiUserQuery, E, D, (StudioIsStudioAiUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<StudioIsStudioAiUserQuery, E, D, (StudioIsStudioAiUserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...studioIsStudioAIUserQueryOptions(variables, fetchOptions),
    })
}